/**
 * L'aspetto della mappa delle aziende: i colori di terra, mare e livelli, e le misure che si ripetono.
 *
 * La mappa è una carta: l'Italia bianca come il foglio, appoggiata su un mare color osso un tono più scuro della
 * pagina, con un filo d'ombra sotto e il reticolo dei gradi. I colori dei livelli sono quelli della console
 * (`theme.ts`, gli stessi di `TierBadge`): Free e Base sono entrambi grigi, quindi Free si distingue per la FORMA, il
 * solo contorno senza riempimento.
 */
import { tokens } from '../../theme';
import type { LivelloMappa } from '@shared/admin/mappaAziende';

export const COLORI_MAPPA = {
  mare: '#EFEEE8',
  reticolo: '#DFDDD4',
  terra: tokens.color.paper,
  ombra: '#DCDAD0',
  confine: '#DEDDE2',
  inchiostro: tokens.color.graphite,
  spento: tokens.color.mist,
  /** Chi lavora adesso: il verde universale di «in linea», lo stesso nella carta e nel pannello. */
  adesso: tokens.color.success,
} as const;

export const COLORE_LIVELLO: Record<LivelloMappa, string> = {
  free: tokens.color.tierFree.light,
  base: tokens.color.tierFree.main,
  pro: tokens.color.tierPro.main,
  business: tokens.color.tierBusiness.main,
};

/** La larghezza del pannello sul computer. */
export const LARGHEZZA_PANNELLO = 392;
/** Sotto questa larghezza (la stessa del menu della console) il pannello diventa un foglio che sale dal basso. */
export const PUNTO_TELEFONO = 'md' as const;
/** L'altezza del foglio chiuso sul telefono: si vede il riepilogo in una riga e la maniglia. */
export const FOGLIO_CHIUSO = 96;
